import { motion } from "framer-motion";
import { useI18n } from "../../i18n/LanguageProvider";
import { Container } from "../Container";
import { StoreBadges } from "../StoreBadges";
import { MoneyPill } from "../AppUI";

const ease = [0.22, 1, 0.36, 1];

export function FinalCta() {
  const { t } = useI18n();
  return (
    <section id="download" className="relative overflow-hidden py-24 md:py-32">
      {/* vibrant brand gradient base */}
      <div className="absolute inset-0" style={{ background: "linear-gradient(135deg, #067d5b 0%, #08AC7D 38%, #4DD79A 100%)" }} />
      {/* color blobs for depth */}
      <div className="pointer-events-none absolute -left-20 top-10 h-80 w-80 rounded-full bg-[#B8F5D6] opacity-40 blur-3xl" />
      <div className="pointer-events-none absolute right-0 -bottom-24 h-96 w-96 rounded-full bg-[#0A0A0A] opacity-30 blur-3xl" />
      <div className="pointer-events-none absolute right-1/4 top-0 h-64 w-64 rounded-full bg-[#FFD59E] opacity-25 blur-3xl mix-blend-overlay" />
      <div className="noise absolute inset-0" />

      <Container className="relative">
        <div className="relative mx-auto max-w-3xl">
          {/* floating pills */}
          <MoneyPill
            label={t("appui.collected")}
            amount="1.240 €"
            className="absolute -left-2 -top-6 z-20 hidden sm:inline-flex md:-left-16"
          />
          <MoneyPill
            label={t("appui.collected")}
            amount="320 €"
            delay={0.15}
            className="absolute -right-2 top-1/3 z-20 hidden sm:inline-flex md:-right-16"
          />

          <motion.div
            initial={{ opacity: 0, y: 30, scale: 0.97 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease }}
            className="relative overflow-hidden rounded-[2.5rem] bg-white px-8 py-14 text-center shadow-[0_50px_120px_-40px_rgba(0,0,0,0.5)] md:px-16 md:py-20"
          >
            <p className="mb-6 text-xs font-semibold uppercase tracking-[0.2em] text-green">{t("hero.availability")}</p>
            <h2 className="mx-auto max-w-2xl text-4xl font-semibold leading-[1.05] tracking-tighter text-black sm:text-5xl lg:text-6xl">
              {t("finalCta.title")}
              <span className="mt-2 block text-black/40">{t("finalCta.subtitle")}</span>
            </h2>

            <div className="mt-10 flex justify-center">
              <StoreBadges height={50} />
            </div>
          </motion.div>
        </div>
      </Container>
    </section>
  );
}
